module.exports = __webpack_public_path__ + "img/case-ct_compactsnipers.9f99c91.png";